let selectedProducts = {};

const BUNDLE_VARIANTS = {
  mixed_50: 47296317292706,
  mixed_100: 47296316932258,

  premium_50: 47277132578978,
  premium_100: 47277132677282,

  signature_50: 47277132546210,
  signature_100: 47277132644514
};

const bundlePrices = {
  premium_100ml: 2499,
  signature_100ml: 2199,
  mixed_100ml: 2299,

  premium_50ml: 1699,
  signature_50ml: 1599,
  mixed_50ml: 1659
};

document.addEventListener('DOMContentLoaded', () => {

  const tabs = document.querySelectorAll('.velora-tab');

  tabs.forEach(tab => {

    tab.addEventListener('click', () => {

      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      const size = tab.dataset.size;

      // Clear selections when switching size
      selectedProducts = {};

      document.querySelectorAll('.velora-qty-value')
        .forEach(el => {
          el.textContent = 0;
        });

      document.querySelectorAll('.velora-product-card')
        .forEach(card => {

          card.style.display =
            card.dataset.size === size
              ? 'block'
              : 'none';

        });

      updateStickyBar();
      updateButtonStates();

    });

  });

  convertButtons();

  updateStickyBar();

  bindCartButton();

});

function convertButtons() {

  document.querySelectorAll('.velora-add-btn')
    .forEach(btn => {

      const card =
        btn.closest('.velora-product-card');

      const handle =
        card.dataset.handle;

      btn.outerHTML = `
        <div class="velora-qty" data-handle="${handle}">
          <button class="velora-minus">−</button>
          <span class="velora-qty-value">0</span>
          <button class="velora-plus">+</button>
        </div>
      `;

    });

  bindQtyButtons();

}

function bindQtyButtons() {

  document.querySelectorAll('.velora-plus')
    .forEach(btn => {

      btn.addEventListener('click', () => {

        const totalSelected =
          getTotalSelected();

        if (totalSelected >= 3) return;

        const qtyWrap =
          btn.closest('.velora-qty');

        const handle =
          qtyWrap.dataset.handle;

        selectedProducts[handle] =
          (selectedProducts[handle] || 0) + 1;

        updateCardQty(qtyWrap, handle);

        updateStickyBar();

        updateButtonStates();

      });

    });

  document.querySelectorAll('.velora-minus')
    .forEach(btn => {

      btn.addEventListener('click', () => {

        const qtyWrap =
          btn.closest('.velora-qty');

        const handle =
          qtyWrap.dataset.handle;

        if (!selectedProducts[handle]) return;

        selectedProducts[handle]--;

        if (selectedProducts[handle] <= 0) {
          delete selectedProducts[handle];
        }

        updateCardQty(qtyWrap, handle);

        updateStickyBar();

        updateButtonStates();

      });

    });

}

function updateCardQty(qtyWrap, handle) {

  qtyWrap.querySelector('.velora-qty-value')
    .textContent =
      selectedProducts[handle] || 0;

}

function getTotalSelected() {

  return Object.values(selectedProducts)
    .reduce((a, b) => a + b, 0);

}

function updateStickyBar() {

  const total =
    getTotalSelected();

  const count =
    document.querySelector('.velora-count');

  const message =
    document.querySelector('.velora-message');

  const cartButton =
    document.querySelector('.velora-cart-btn');

  const mrpBox =
    document.querySelector('.velora-mrp');

  const bundleBox =
    document.querySelector('.velora-bundle-price');

  const savingBox =
    document.querySelector('.velora-saving');

  count.textContent =
    `${total} / 3 Selected`;

  let totalMRP = 0;
  let premiumCount = 0;
  let signatureCount = 0;

  Object.entries(selectedProducts)
    .forEach(([handle, qty]) => {

      const card =
        document.querySelector(
          `[data-handle="${handle}"]`
        );

      if (!card) return;

      const price =
        Number(card.dataset.price);

      totalMRP += price * qty;

      if (card.dataset.collection === 'premium') {
        premiumCount += qty;
      }

      if (card.dataset.collection === 'signature') {
        signatureCount += qty;
      }

    });

  if (total < 3) {

    message.textContent =
      `Select ${3 - total} more fragrance${(3 - total) === 1 ? '' : 's'}`;

    mrpBox.innerHTML =
      totalMRP > 0
        ? `Current MRP: ₹${totalMRP}`
        : '';

    bundleBox.innerHTML = '';
    savingBox.innerHTML = '';

    cartButton.disabled = true;

    return;
  }

  let summary = [];

  Object.entries(selectedProducts)
    .forEach(([handle, qty]) => {

      const card =
        document.querySelector(
          `[data-handle="${handle}"]`
        );

      if (!card) return;

      summary.push(
        `${card.dataset.title} × ${qty}`
      );

    });

  message.textContent =
    summary.join(' • ');

  const activeTab =
    document.querySelector('.velora-tab.active');

  const size =
    activeTab.dataset.size;

  let bundleType = 'mixed';

  if (premiumCount === 3) {
    bundleType = 'premium';
  }

  if (signatureCount === 3) {
    bundleType = 'signature';
  }

  const bundlePrice =
    bundlePrices[
      `${bundleType}_${size}`
    ];

  const additionalSaving =
    totalMRP - bundlePrice;

  mrpBox.innerHTML =
    `MRP: <s>₹${totalMRP}</s>`;

  bundleBox.innerHTML =
    `Bundle Price: ₹${bundlePrice}`;

  savingBox.innerHTML =
    `Additional Saving: ₹${additionalSaving}`;

  cartButton.disabled = false;

}

function updateButtonStates() {

  const total =
    getTotalSelected();

  document.querySelectorAll('.velora-plus')
    .forEach(btn => {

      const qtyWrap =
        btn.closest('.velora-qty');

      const handle =
        qtyWrap.dataset.handle;

      const currentQty =
        selectedProducts[handle] || 0;

      if (
        total >= 3 &&
        currentQty === 0
      ) {

        btn.disabled = true;
        btn.classList.add('disabled');

      } else {

        btn.disabled = false;
        btn.classList.remove('disabled');

      }

    });

}

function bindCartButton() {

  const cartBtn =
    document.querySelector('.velora-cart-btn');

  if (!cartBtn) return;

  cartBtn.addEventListener('click', async () => {

    const totalSelected =
      getTotalSelected();

    if (totalSelected !== 3) return;

    const activeSize =
      document.querySelector('.velora-tab.active')
        .dataset.size;

    const sizeKey =
      activeSize === '100ml'
        ? '100'
        : '50';

    let premiumCount = 0;
    let signatureCount = 0;

    Object.entries(selectedProducts)
      .forEach(([handle, qty]) => {

        const card =
          document.querySelector(
            `[data-handle="${handle}"]`
          );

        if (!card) return;

        if (card.dataset.collection === 'premium') {
          premiumCount += qty;
        }

        if (card.dataset.collection === 'signature') {
          signatureCount += qty;
        }

      });

    let bundleKey;

    if (premiumCount === 3) {

      bundleKey = `premium_${sizeKey}`;

    } else if (signatureCount === 3) {

      bundleKey = `signature_${sizeKey}`;

    } else {

      bundleKey = `mixed_${sizeKey}`;

    }

    const bundleVariantId =
      BUNDLE_VARIANTS[bundleKey];

    const properties = {};

let line = 1;

Object.entries(selectedProducts)
  .forEach(([handle, qty]) => {

    const card =
      document.querySelector(
        `[data-handle="${handle}"]`
      );

    if (!card) return;

    const image =
      card.querySelector('img')?.src || '';

    properties[
      `Fragrance_${line}`
    ] = card.dataset.title;

    properties[
      `Qty_${line}`
    ] = qty;

    properties[
      `Image_${line}`
    ] = image;

    line++;

  });

    try {

      const response =
        await fetch('/cart/add.js', {

          method: 'POST',

          headers: {
            'Content-Type': 'application/json'
          },

          body: JSON.stringify({

            items: [
              {
                id: bundleVariantId,
                quantity: 1,
                properties
              }
            ]

          })

        });

      if (!response.ok) {
  throw new Error(
    'Failed to add bundle'
  );
}

/* OPEN CART DRAWER INSTEAD OF GOING TO /cart */

const cartDrawer =
  document.querySelector('cart-drawer');

if (cartDrawer) {

  try {

    const drawerResponse =
      await fetch('/?section_id=cart-drawer');

    const html =
      await drawerResponse.text();

    const parser =
      new DOMParser();

    const doc =
      parser.parseFromString(
        html,
        'text/html'
      );

    const newDrawer =
      doc.querySelector('cart-drawer');

    if (newDrawer) {

      cartDrawer.innerHTML =
        newDrawer.innerHTML;

    }

    cartDrawer.classList.remove('is-empty');

    if (
      typeof cartDrawer.open ===
      'function'
    ) {

      cartDrawer.open();

    }

  } catch (e) {

    console.error(
      'Drawer refresh failed',
      e
    );

  }

}

    } catch (error) {

      console.error(error);

      alert(
        'Unable to add bundle to cart'
      );

    }

  });

}



